import { GetCountriesData } from '@shared/interfaces/api.interfaces';
import { LatinLettersTooltip } from '../components/addresses/city-select-international/city-select.constants';
import { CountryRecipientPayerConfig, DefaultCountryPhoneConfig } from '../international-invoice.constants';

// Great Britain
export const GB: Partial<GetCountriesData> = {
  ...DefaultCountryPhoneConfig,
  ...CountryRecipientPayerConfig,
  CityTooltip: LatinLettersTooltip,
  RecipientPostboxAvailable: true,
  RecipientSpotSelectionAvailable: true,
  RecipientPayerAllowed: true,
};
